import { versa } from '@epihub/core/src/versa';
import type { ThemeDefV0 } from './versions/ThemeDefV0';

export type ColorScheme = 'light' | 'dark';

export type ThemeVersions = 'v0';

export const themeVersioner = versa('Theme', {
  versionMap: {
    v0: (data: ThemeDefV0['Theme']) => data.__version === 'v0',
  },
  migrations: {},
});

export const themeStateVersioner = versa('ThemeState', {
  versionMap: {
    v0: (data: ThemeDefV0['State']) => data.__version === 'v0',
  },
  migrations: {},
});
